/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * HyusnSu Sim (hssim@rsupport.com)
 *
 * @description
 *
 * @created at Thu Mar 23 2023
 **/

import { useContext } from "react";
import { UseStateContext } from "./TabContainer";

interface TabContentProps extends React.HTMLAttributes<HTMLDivElement> {
	displayType?: "normal" | "hidden";
	activeId: string;
	children: React.ReactNode;
}

export default function TabContent({ activeId, children, ...rest }: TabContentProps) {
	const { currentId, displayType } = useContext(UseStateContext);

	if (displayType === "hidden") return HiddenComponent({ activeId, currentId, children, ...rest });

	if (activeId !== currentId) return null;
	return (
		<div css={{ width: "100%" }} {...rest}>
			{children}
		</div>
	);
}

function HiddenComponent({ activeId, currentId, children, ...rest }: TabContentProps & { currentId: string }) {
	if (activeId !== currentId) {
		return (
			<div {...rest} style={{ display: "none" }}>
				{children}
			</div>
		);
	} else {
		return <div {...rest}>{children}</div>;
	}
}
